import { kebabCase } from 'lodash';
import React from 'react';

import './EarlyWithdrawalPenalty.scss';

import { EARLY_WITHDRAWAL_PENALTY_AGE } from '../../../settings/settings';

const EarlyWithdrawalPenalty = ({ ticker }) => (
  <div
    className={`early-withdrawal-container e2e-early-withdrawal-penalty-${kebabCase(
      ticker
    )}`}
  >
    <h6 className="early-withdrawal-emphasize">Early Withdrawal Warning</h6>
    <p className={`e2e-early-withdrawal-text-${kebabCase(ticker)}`}>
      A 10% additional tax for early withdrawal may apply for distributions made
      before reaching age {EARLY_WITHDRAWAL_PENALTY_AGE}.
    </p>
  </div>
);

export default EarlyWithdrawalPenalty;
